import "./app/publicPath";
// import "./error-handler"
import Vue from "vue";
import NotificationService from "./app/services/NotificationService";
import TranslationService from "./app/services/TranslationService";
import "bootstrap";
window._owlc = () => import("owl.carousel");
import { createApp, beforeCreate } from "./app";
import "custom-event-polyfill";
import { initClientListeners, initClientStore, createStore, VuexModule } from "./app/store";
import ApiService, { initListener, post } from "./app/services/ApiService";
// import { mount } from "./mount";
import "./app/jQuery";

// Vue.prototype.$mount = mount;

// defines if the render location is the client
App.isSSR = false;
App.isSSREnabled = App.config.log.performanceSsr;

beforeCreate();

window.createApp = (selector) =>
{
    // client-specific bootstrapping logic...
    const app = createApp({
        template: "#ssr-script-container"
    }, store);

    app.$mount(selector, true);
    window.vueApp = app;

    initListener();

    initClientListeners(store);
    initClientStore(store);
};

const store = createStore();

if (window.__INITIAL_STATE__)
{
    store.replaceState(window.__INITIAL_STATE__);
}

window.Vue = Vue;
window.Vuex = VuexModule;
window.NotificationService = NotificationService;
window.ceresTranslate = TranslationService.translate;
window.vueEventHub = new Vue();
window.ceresStore = store;

import "./app/main";

import * as Sentry from "@sentry/vue";

if(window.App?.modeherzPluginConfig.errorLogging) {
    Sentry.init({
        release: 'modeherz@' + window.App?.modeherzPluginConfig.version,
        Vue: Vue,
        attachProps: true,
        dsn: "https://a6033ad31272bc91c4332912c23c1bf4@o4508120643993600.ingest.de.sentry.io/4508120645369936",
        integrations: [
            // Sentry.replayIntegration(),
            Sentry.browserProfilingIntegration(),
            Sentry.captureConsoleIntegration({levels: ['error']})
        ],
        profilesSampleRate: 0.05, // Profile 100% of the transactions. This value is relative to tracesSampleRate
        replaysOnErrorSampleRate: 1.0,
    });
}
